import React from "react";
import useStyles from "../styles";
import Table from "@material-ui/core/Table";
import {TableCell, TableHead, TableRow} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import {ArrowBackIosRounded, ArrowForwardIosRounded} from "@material-ui/icons";
import TableBody from "@material-ui/core/TableBody";
import moment from "moment";

const SelectedMonth = ({selectedMonth, selectedWorkDays, months, handleChoseAnotherMonth, monthDays, selectedDay,
                           year, handleClickOnDay}) => {
    const classes = useStyles();

    return (selectedMonth && selectedWorkDays && months && <div className={classes.selectedMonth}>
            <div className={classes.monthHeading}>
                <h1 className={classes.monthHeadingText}>
                    ВИБРАНА ДАТА
                </h1>
            </div>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        {months.length > 1 && <TableCell className={classes.tableCell}>
                            <IconButton
                                size="small"
                                onClick={event => handleChoseAnotherMonth(event, 'back')}
                            >
                                <ArrowBackIosRounded/>
                            </IconButton>
                        </TableCell>}
                        <TableCell
                            colSpan={months.length > 1 ? 5 : 7}
                            className={classes.tableHeadMonthName}
                        >
                            {selectedMonth}
                        </TableCell>
                        {months.length > 1 && <TableCell className={classes.tableCell}>
                            <IconButton
                                size="small"
                                onClick={event => handleChoseAnotherMonth(event, 'forward')}
                            >
                                <ArrowForwardIosRounded/>
                            </IconButton>
                        </TableCell>}
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.tableCellBorderNone}>Пн</TableCell>
                        <TableCell className={classes.tableCellBorderNone}>Вт</TableCell>
                        <TableCell className={classes.tableCellBorderNone}>Ср</TableCell>
                        <TableCell className={classes.tableCellBorderNone}>Чт</TableCell>
                        <TableCell className={classes.tableCellBorderNone}>Пт</TableCell>
                        <TableCell className={classes.tableCellBorderNone}>Сб</TableCell>
                        <TableCell className={classes.tableCellBorderNone}>Нд</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {monthDays && selectedWorkDays && monthDays.map((week, idx) => {
                        return (<TableRow key={'week' + idx}>
                            {week.map((day, index) => {
                                const isAvailableDay = selectedWorkDays
                                    .filter(item => +moment(item.dt_start).date() === +day.dayNum && moment(item.dt_start).year() === year
                                        && moment().year(year).month(selectedMonth).month() === moment(item.dt_start).month())
                                    .reduce((acu, cur) => {
                                        if (moment(cur.dt_start).year() < year && moment(cur.dt_start).dayOfYear() < moment().dayOfYear()) return false;
                                        if (moment(cur.dt_start).dayOfYear() === moment().dayOfYear() && moment(cur.dt_end).hour() < moment().year(year).hour()) return false;
                                        if (+moment(cur.dt_start).date() === +day.dayNum && moment(cur.dt_start).year() === year) return true;

                                        return acu;
                                    }, false);

                                const isDayActive = selectedDay && (day.dayNum === moment(selectedDay.dt_start).date());

                                return (<TableCell
                                    key={day.dayNum + '' + idx + '' + index}
                                    className={isAvailableDay
                                        ? isDayActive ? classes.dayCellActive : classes.dayCell
                                        : classes.dayCellLock}
                                    onClick={(event) => isAvailableDay && !isDayActive && handleClickOnDay(event, day.dayNum)}
                                >
                                    {day.dayNum}
                                </TableCell>);
                            })}
                        </TableRow>)
                    })}
                </TableBody>
            </Table>
        </div>);
};

export default SelectedMonth;
